import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import { clinicId } from "../../../constants";
import { Button, CircularProgress } from "@mui/material";
import { useMutation } from "react-query";
import { fitCertificate } from "./services";
import usePrint from "../../../hooks/usePrint";
import { EmrContext } from "../../index";
import { useContext } from "react";
import usePopup from "@hooks/usePopup";
import useAuthentication from "../../../hooks/useAuthentication";

const FitForCertificateForm = () => {
  const { control, handleSubmit, reset } = useForm();
  const { printPdf } = usePrint();
  const { showSnackbar } = usePopup();
  const { patientData } = useContext(EmrContext);
  const {user} = useAuthentication()
  const { mutate, isLoading } = useMutation(fitCertificate, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success" && result.response) {
        printPdf(result.response);
        reset();
      }
    },
    onError: () => {
      showSnackbar({
        message: "Something went wrong",
        variant: "error",
        open: true,
        duration: 3000,
      });
    },
  });

  const onSubmit = (data: any) => {
    const body = {
      clinicId: clinicId,
      clinicianId: Number(user?.clinicianID),
      from: data?.from,
      to: data?.to,
      name: data?.name,
      type: data.type,
      deptId: Number(patientData?.encounter?.departmentId),
    };
    mutate(body);
  };

  const handleReset = () => {
    reset();
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-3 gap-3">
      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "Name" }}
        name="name"
        rules={{ required: "Name required" }}
      />

      <CustomFormField
        control={control}
        element="autocomplete"
        options={["Fit for Work", "Not fit for work "]}
        fieldProps={{ label: "Type" }}
        name="type"
        rules={{ required: "Type required" }}
      />

      <CustomFormField
        control={control}
        element="datepicker"
        fieldProps={{ label: "From date" }}
        name="from"
        rules={{ required: "From date required" }}
      />
      <CustomFormField
        control={control}
        element="datepicker"
        fieldProps={{ label: "to date" }}
        name="to"
        rules={{ required: "To date required" }}
      />

      <div className="flex gap-x-2  items-center">
        <Button
          type="submit"
          color="success"
          disabled={isLoading}
          endIcon={isLoading && <CircularProgress size={20} />}
        >
          submit
        </Button>
        <Button onClick={handleReset} color="error">
          reset
        </Button>
      </div>
    </form>
  );
};

export default FitForCertificateForm;